export const API_URL: string = process.env.REACT_APP_API_URL as string;
